import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { internalGames } from '../games/registry';
import { ExternalGameRedirect } from '../games/shared/ExternalGameRedirect';
import { GameHomeLink } from '../games/shared/GameHomeLink';
import { ClassicHomePage } from '../pages/home/ClassicHomePage';
import { HomePage } from '../pages/home/HomePage';
import { NotFoundPage } from '../pages/not-found/NotFoundPage';

const lazyGames = Object.fromEntries(
  internalGames.map((game) => [game.slug, lazy(game.load)]),
);

const inlineHomeLinkSlugs = new Set([
  'memory-flip',
  'minesweeper',
  'rock-paper-scissors',
  'tile-matching',
  'typing-room',
  'wordle',
]);

function GameLoading() {
  return (
    <main className="route-loading" aria-live="polite">
      <span className="route-loading__dot" />
      正在打开游戏…
    </main>
  );
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/classic" element={<ClassicHomePage />} />
      <Route path="/games/jargon" element={<ExternalGameRedirect href="https://techjargon.sharkrepos.net" />} />
      {internalGames.map((game) => {
        const Game = lazyGames[game.slug];
        const inlineHomeLink = inlineHomeLinkSlugs.has(game.slug);
        return (
          <Route
            key={game.slug}
            path={game.path}
            element={
              <div className={`game-route game-route--${game.slug}`}>
                {!inlineHomeLink && <GameHomeLink className={`game-home-link--${game.slug}`} iconOnly={game.slug === 'wordle'} />}
                <Suspense fallback={<>{inlineHomeLink && <GameHomeLink className={`game-home-link--${game.slug}`} iconOnly={game.slug === 'wordle'} />}<GameLoading /></>}>
                  <Game />
                </Suspense>
              </div>
            }
          />
        );
      })}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
